import { authGuard, permissionGuard } from '@abp/ng.core';
import { Routes } from '@angular/router';

export const APP_ROUTES: Routes = [
  {
    path: '',
    pathMatch: 'full',
    loadChildren: () => import('./home/home.routes').then(m => m.HOME_ROUTES),
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./dashboard/dashboard.routes').then(m => m.DASHBOARD_ROUTES),
  },
  {
    path: 'account',
    loadChildren: () => import('@volo/abp.ng.account/public').then(m => m.createRoutes()),
  },
  {
    path: 'gdpr',
    loadChildren: () => import('@volo/abp.ng.gdpr').then(m => m.createRoutes()),
  },
  {
    path: 'identity',
    loadChildren: () => import('@volo/abp.ng.identity').then(m => m.createRoutes()),
  },
  {
    path: 'language-management',
    loadChildren: () => import('@volo/abp.ng.language-management').then(m => m.createRoutes()),
  },
  {
    path: 'saas',
    loadChildren: () => import('@volo/abp.ng.saas').then(m => m.createRoutes()),
  },
  {
    path: 'audit-logs',
    loadChildren: () => import('@volo/abp.ng.audit-logging').then(m => m.createRoutes()),
  },
  {
    path: 'openiddict',
    loadChildren: () => import('@volo/abp.ng.openiddictpro').then(m => m.createRoutes()),
  },
  {
    path: 'text-template-management',
    loadChildren: () => import('@volo/abp.ng.text-template-management').then(m => m.createRoutes()),
  },
  {
    path: 'setting-management',
    loadChildren: () => import('@abp/ng.setting-management').then(m => m.createRoutes()),
  },
  {
    path: 'gdpr-cookie-consent',
    loadChildren: () =>
      import('./gdpr-cookie-consent/gdpr-cookie-consent.routes').then(
        m => m.GDPR_COOKIE_CONSENT_ROUTES,
      ),
  },
  {
    path: 'domains',
    loadChildren: () => import('./domains/domain/domain.routes').then(m => m.DOMAIN_ROUTES),
  },
  {
    path: 'domain-users',
    loadChildren: () =>
      import('./domain-users/domain-user/domain-user.routes').then(m => m.DOMAIN_USER_ROUTES),
  },
  {
    path: 'pstfiles',
    loadChildren: () => import('./pstfiles/pstfile/pstfile.routes').then(m => m.PSTFILE_ROUTES),
  },
  {
    path: 'agents',
    loadChildren: () => import('./agents/agent/agent.routes').then(m => m.AGENT_ROUTES),
  },
  {
    path: 'modules',
    loadChildren: () => import('./agents/module/module.routes').then(m => m.MODULE_ROUTES),
  },
  {
    path: 'active-agent-updates',
    loadChildren: () =>
      import('./active-agent-updates/active-agent-updates/active-agent-updates.routes').then(
        m => m.ACTIVE_AGENT_UPDATES_ROUTES,
      ),
  },
  {
    path: 'mappings',
    loadChildren: () => import('./mappings/mapping/mapping.routes').then(m => m.MAPPING_ROUTES),
  },
  {
    path: 'migration-processes',
    loadChildren: () =>
      import('./migration-processes/migration-process/migration-process.routes').then(
        m => m.MIGRATION_PROCESS_ROUTES,
      ),
  },
  {
    path: 'aadtenants',
    loadChildren: () =>
      import('./aadtenants/aadtenant/aadtenant.routes').then(m => m.AADTENANT_ROUTES),
  },
  {
    path: 'retention-periods',
    loadChildren: () =>
      import('./retention-management/retention-periods/retention-periods.routes').then(
        m => m.RETENTION_PERIODS_ROUTES,
      ),
  },
  {
    path: 'retention-packages',
    loadChildren: () =>
      import('./retention-management/retention-packages/retention-packages.routes').then(
        m => m.RETENTION_PACKAGES_ROUTES,
      ),
  },
  {
    path: 'retention-policies',
    loadChildren: () =>
      import('./retention-management/retention-policies/retention-policies.routes').then(
        m => m.RETENTION_POLICIES_ROUTES,
      ),
  },
  {
    path: 'central-unc-shares',
    loadChildren: () =>
      import('./central-unc-shares/central-unc-shares.routes').then(
        m => m.CENTRAL_UNC_SHARES_ROUTES,
      ),
  },
  {
    path: 'network-definition',
    loadChildren: () =>
      import('./network-definitions/network-definition/network-definition.routes').then(
        m => m.NETWORK_DEFINITION_ROUTES,
      ),
  },
  {
    path: 'email-templates',
    loadChildren: () =>
      import('./email-templates/email-templates/email-templates.routes').then(
        m => m.EMAIL_TEMPLATES_ROUTES,
      ),
  },
  {
    path: 'agent-api-keys',
    loadChildren: () =>
      import('./agent-api-keys/agent-api-key/agent-api-key.routes').then(
        m => m.AGENT_API_KEY_ROUTES,
      ),
  },
  {
    path: 'mapping-progress',
    loadChildren: () =>
      import('./mapping-progress/mapping-progress/mapping-progress.routes').then(
        m => m.MAPPING_PROGRESS_ROUTES,
      ),
  },
  {
    path: 'agent-update-tier',
    loadChildren: () =>
      import('./agent-update-tier/agent-update-tier/agent-update-tier.routes').then(
        m => m.AGENT_UPDATE_TIER_ROUTES,
      ),
  },
  {
    path: 'pst-progress-overview',
    loadChildren: () =>
      import('./pst-progress-overview/pst-progress-overview.routes').then(
        m => m.PST_PROGRESS_OVERVIEW_ROUTES,
      ),
  },
  {
    path: 'migration-progress-overview',
    loadChildren: () =>
      import('./migration-progress-overview/migration-progress-overview.routes').then(
        m => m.MIGRATION_PROGRESS_OVERVIEW_ROUTES,
      ),
  },
  {
    path: 'pst-file-owner-management',
    loadChildren: () =>
      import('./pst-file-owner-management/pst-file-owner-management.routes').then(
        m => m.PST_FILE_OWNER_MANAGEMENT_ROUTES,
      ),
  },
  {
    path: 'pst-file-excludes',
    loadChildren: () =>
      import('./pst-file-excludes/pst-file-excludes.routes').then(m => m.PST_FILE_EXCLUDES_ROUTES),
  },
  {
    path: 'finished-mappings',
    loadChildren: () =>
      import('./mapping-progress/finished-mappings/finished-mappings.routes').then(
        m => m.FINISHED_MAPPINGS_ROUTES,
      ),
  },
  {
    path: 'pst-file-item-errors',
    loadChildren: () =>
      import('./pst-item-errors/pst-item-errors.routes').then(m => m.PST_FILE_ITEM_ERRORS_ROUTES),
  },
];
